<template>
  <div class="dialog-container" v-loading="isLoading">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <h3 class="mt-0">This action requires approval from a supervisor.</h3>
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="userSignin" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Username" prop="username">
            <el-input v-model="form.username" placeholder="Username" @keyup.enter.native="prepareAuth"></el-input>
          </el-form-item>
          <el-form-item label="Password" prop="password">
            <el-input type="password" v-model="form.password" placeholder="Password" @keyup.enter.native="prepareAuth"></el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="prepareAuth">Sign In</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { Required, Password } from '@/util/formValidators';

export default {
  props: {
    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      isLoading: false,
      errorMessage: '',
      form: {
        username: null,
        password: null,
      },
      rules: {
        username: [Required],
        password: [Required, Password],
      },
    };
  },
  methods: {
    ...mapActions('User', ['authenticateSupervisor']),
    async prepareAuth() {
      this.errorMessage = '';
      const valid = await this.$refs.userSignin.validate();
      if (valid) {
        try {
          this.isLoading = true;
          const response = await this.authenticateSupervisor({
            Username: this.form.username.toLowerCase(),
            Password: this.form.password,
          });

          this.callback(response.accessToken);
          this.closeDialog();
        } catch (e) {
          this.errorMessage = e || 'An error occurred. Please try again.';
        } finally {
          this.isLoading = false;
        }

        return true;
      }

      return false;
    },
    closeDialog() {
      this.form.username = null;
      this.form.password = null;
      this.isLoading = false;
      this.errorMessage = '';
      this.$emit('close');
    },
  },
};

</script>
